<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
// Teletel APIs serialize ISO-8601 timestamps (dynamicTime expects unix).
const formatTime = value => (value ? new Date(value).toLocaleString() : '');

const store = useStore();
const { t } = useI18n();

const meta = computed(() => store.getters['teletelFlows/getMeta']);
const runs = computed(() => store.getters['teletelFlows/getRuns']);
const flows = computed(() => store.getters['teletelFlows/getFlows']);

onMounted(() => {
  store.dispatch('teletelFlows/get');
  store.dispatch('teletelFlows/fetchRuns', { status: 'failed' });
});

const flowName = id => flows.value.find(f => f.id === id)?.name || `#${id}`;
</script>

<template>
  <div class="flex flex-col gap-4 p-6 overflow-auto">
    <h1 class="text-xl font-medium text-n-slate-12">
      {{ t('TELETEL_FLOWS.ERRORS_PAGE.HEADER') }}
    </h1>

    <section class="p-4 border rounded-xl border-n-weak">
      <h2 class="mb-1 text-base font-medium text-n-slate-12">
        {{ t('TELETEL_FLOWS.ERRORS_PAGE.SELECTOR_TITLE') }}
      </h2>
      <p
        v-if="meta.selectorErrors > 0"
        class="p-3 text-sm rounded-lg bg-n-ruby-3 text-n-ruby-11"
      >
        {{
          t('TELETEL_FLOWS.SELECTOR_ALERT', {
            count: meta.selectorErrors,
            last: meta.selectorLastError || '—',
          })
        }}
      </p>
      <p v-else class="text-sm text-n-teal-11">
        {{ t('TELETEL_FLOWS.ERRORS_PAGE.SELECTOR_OK') }}
      </p>
    </section>

    <section class="p-4 border rounded-xl border-n-weak">
      <h2 class="mb-2 text-base font-medium text-n-slate-12">
        {{ t('TELETEL_FLOWS.ERRORS_PAGE.FAILED_RUNS') }}
      </h2>
      <p v-if="!runs.length" class="text-sm text-n-slate-11">
        {{ t('TELETEL_FLOWS.ERRORS_PAGE.NONE_FAILED') }}
      </p>
      <ul v-else class="flex flex-col gap-1 text-sm text-n-slate-11">
        <li v-for="run in runs" :key="run.id">
          {{ formatTime(run.created_at) }} · {{ flowName(run.flow_id) }} · #{{
            run.conversation_id
          }}
          — {{ run.failure_reason || '—' }}
        </li>
      </ul>
    </section>
  </div>
</template>
